export default __webpack_public_path__ + "static/media/shape1.4b80082c.svg";